import React, { Fragment,  } from 'react';

import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import RundedrehenMapItemsListSkeletonRow from './rundedrehen-map-items-list-skeletonrow';

'use strict';

function RundedrehenMapItemsListSkeleton({image}) {


  return <Fragment>
    <SkeletonTheme baseColor="#dbdbdb" highlightColor="#e5e5e5">
      <div className="
        px-3 md:px-4
        pt-1
        -mb-0.5
      ">
        <Skeleton height="14px" width="110px"></Skeleton>
      </div>

      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'}/>
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'}/>
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'}/>
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'}/>

      <div className="
        px-3 md:px-4
        pt-12
        -mb-0.5
      ">
        <Skeleton height="14px" width="110px"></Skeleton>
      </div>

      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'}/>
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'}/>
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'}/>
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'}/>
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'}/>
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'}/>
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'}/>
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'}/>

      <div className="
        px-3 md:px-4
        pt-12
        -mb-0.5
      ">
        <Skeleton height="14px" width="110px"></Skeleton>
      </div>

      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'}/>
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'}/>
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'}/>
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'}/>
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'}/>
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'}/>
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'}/>
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'}/>
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'}/>
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'}/>

      <div className="
        px-3 md:px-4
        pt-10
        -mb-0.5
      ">
        <Skeleton height="14px" width="110px"></Skeleton>
      </div>

      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'} />
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'} />
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'} />
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'} />
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'} />
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'} />
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'} />
      <RundedrehenMapItemsListSkeletonRow image={image} width={(Math.floor(Math.random() * (85 - 60 + 1)) + 60) + '%'} />

    </SkeletonTheme>
  </Fragment>

}

export default RundedrehenMapItemsListSkeleton;
